import React from 'react'
import PropTypes from 'prop-types'
import Field, { useFieldId, messageIdFor } from 'components/ds/Field'
import styles from './Input.module.scss'

const cx = (...p) => p.filter(Boolean).join(' ')

const fieldPropTypes = {
  id: PropTypes.string,
  label: PropTypes.node,
  required: PropTypes.bool,
  hint: PropTypes.node,

  error: PropTypes.node,

  success: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  controlClassName: PropTypes.string,
}

const ariaFor = (fieldId, { error, hint }) => ({
  'aria-invalid': error ? true : undefined,
  'aria-describedby': error || hint ? messageIdFor(fieldId) : undefined,
})

export const Input = React.forwardRef(function Input(props, ref) {
  const {
    id, label, required, hint, error, success, disabled,
    multiline, rows, startIcon, className, controlClassName, ...rest
  } = props
  const fieldId = useFieldId(id)
  const Tag = multiline ? 'textarea' : 'input'

  return (
    <Field id={fieldId} label={label} required={required} hint={hint} error={error} className={className}>
      <div className={styles.wrap}>
        {startIcon && !multiline && (
          <span className={styles.startIcon} aria-hidden="true">{startIcon}</span>
        )}
        <Tag
          ref={ref}
          id={fieldId}
          disabled={disabled}
          rows={multiline ? rows : undefined}
          className={cx(
            styles.control,
            multiline && styles.multiline,
            startIcon && !multiline && styles.hasStartIcon,
            error && styles.error,
            success && !error && styles.success,
            controlClassName
          )}
          {...ariaFor(fieldId, { error, hint })}
          {...rest}
        />
      </div>
    </Field>
  )
})

Input.propTypes = {
  ...fieldPropTypes,
  multiline: PropTypes.bool,
  rows: PropTypes.number,
  startIcon: PropTypes.node,
}

export const Select = React.forwardRef(function Select(props, ref) {
  const {
    id, label, required, hint, error, success, disabled,
    className, controlClassName, children, ...rest
  } = props
  const fieldId = useFieldId(id)

  return (
    <Field id={fieldId} label={label} required={required} hint={hint} error={error} className={className}>
      <div className={styles.wrap}>
        <select
          ref={ref}
          id={fieldId}
          disabled={disabled}
          className={cx(
            styles.control,
            styles.select,
            error && styles.error,
            success && !error && styles.success,
            controlClassName
          )}
          {...ariaFor(fieldId, { error, hint })}
          {...rest}
        >
          {children}
        </select>
      </div>
    </Field>
  )
})

Select.propTypes = {
  ...fieldPropTypes,
  children: PropTypes.node,
}

export default Input
